import React from 'react';

import Expand from '../../components/Expand';

import s from './index.module.css';

const Questions = () => {
  return (
    <section className={s.questionsSection}>
      <h2 className={s.questionsHeader}>Вопросы и ответы</h2>
      <div className={s.questions}>
        <Expand title="Как это работает?" defaultIsExpand={true}>
          <p>Вы загружаете свои предложения на Смартби, например, в экселе.</p>
          <br />

          <p>Мы находим покупателей и приводим на наш сайт.</p>
          <br />

          <p>Покупатели видят ваши предложения.</p>
          <br />

          <p>
            Эксперты Смартби в онлайн-чате подбирают подходящие детали покупателю и оформляют заказ в вашем магазине.
          </p>
          <br />

          <p>В результате вы получаете готовый заказ со средним чеком в 3 599 ₽.</p>
        </Expand>

        <Expand title="Как вы находите новых покупателей? ">
          <p>
            Мы занимаемся рекламой и привлечением и в интернете и в оффлайне. Приводим покупателей, которые в обычной
            жизни, скорее всего, не знают про ваш магазин или покупают у конкурентов.
          </p>
          <br />

          <p>
            Контекстная реклама, поисковая оптимизация, реклама на тематических сайтах, партнерские программы, реклама у
            известных блогеров на YouTube, выступления на мероприятиях и выставках.
          </p>
          <br />

          <p>
            Постоянно ищем новые и эффективные источники. Берём это хлопотное и затратное дело на себя, а вам передаем
            уже готовые заказы и контакты клиента
          </p>
          <br />
        </Expand>

        <Expand title="Как я узнаю о заказе из Смартби?">
          <p>
            У вас будет личный кабинет.
            <br />В нем вы будете загружать предложения, получать заказы, видеть всю информацию о покупателе и
            анализировать статистику продаж.
          </p>
          <br />

          <p>Также в Смартби есть настройка уведомлений на почту.</p>
        </Expand>

        <Expand title="Кто занимается доставкой и выдачей заказа?">
          <p>
            Вы указываете пункт выдачи, телефон и время работы вашего пункта выдачи в личном кабинете Смартби. Мы
            передаем эту информацию покупателям.
          </p>
          <br />

          <p>
            Не вмешиваемся в ваши процессы, не занимаемся логистикой, у нас нет складов и мы не покупаем у вас товар. Вы
            выдаете товар и принимаете оплату от покупателей так, как привыкли.
          </p>
          <br />

          <p>Мы не конкуренты и перекупщики, мы приводим вам новых клиентов.</p>
          <br />

          <p>
            Если у вас нет розничной точки продаж —{' '}
            <a className={s.link} href="mailto:help@smartbe.com">
              напишите нам
            </a>
            , мы поможем подыскать ближайший магазин, который будет сотрудничать с вами и продавать ваш товар.
          </p>
        </Expand>

        <Expand title="Как происходит оплата заказа?">
          <p>Покупатель оплачивает заказ при получении в пункте выдачи</p>
        </Expand>

        <Expand title="Сколько стоят ваши услуги?">
          <p>
            За свои услуги берем 9% с оформленного заказа
            <br />
            Т.е. при среднем чеке в 3 599 руб. за готовый заказ и нового клиента – 323 руб.
          </p>
          <br />

          <p>Всю детализацию вы видите в режиме реального времени в личном кабинете.</p>
          <br />

          <p>
            Работаем по оферте без лишних бумаг и бюрократии.
            <br />В конце месяца пришлём отчёт о выполненных заказах, новых покупателях и среднем чеке. Акт выполненных
            работ и подробную детализацию.
          </p>
          <br />

          <p>
            Мы уверены — вам понравится{' '}
            <span role="img" aria-label="thumbsup">
              👍
            </span>
          </p>
        </Expand>

        <Expand title="Как подключиться? ">
          <p>
            Пройти короткую регистрацию —{' '}
            <a className={s.link} href="/seller/register" target="_blank">
              Подключить магазин
            </a>
          </p>
        </Expand>

        <Expand title="У меня еще вопрос">
          <p>
            Если у вас остались вопросы — напишите на эл.почту{' '}
            <a className={s.link} href="mailto:help@smartbe.com">
              help@smartbe.com
            </a>
          </p>
          <br />

          <p>
            Вместе всё решим{' '}
            <span role="img" aria-label="muscle">
              💪
            </span>
          </p>
        </Expand>
      </div>
    </section>
  );
};

export default Questions;
